import QuoteInfo from './QuoteInfo';
export default QuoteInfo;
